/**
 * CompactChallengeCard - Ultra-compact card for grid view
 * Optimized for iPad display
 */

import type { ChallengeRanking } from '../types';

interface CompactChallengeCardProps {
  challenge: ChallengeRanking;
  rank: number;
}

export function CompactChallengeCard({ challenge, rank }: CompactChallengeCardProps) {
  const isTopRank = rank <= 3;

  return (
    <div className={`compact-card ${isTopRank ? 'top-rank' : ''}`}>
      {/* Rank Badge */}
      <div className={`compact-rank ${isTopRank ? 'top-rank' : ''}`}>
        #{rank}
      </div>

      {/* Challenge Name */}
      <h3 className="compact-challenge-name">
        {challenge.name}
      </h3>

      {/* Mini Progress Bar */}
      <div className="mini-progress-bar">
        <div
          className="mini-progress-fill"
          style={{ width: `${challenge.percentage}%` }}
        />
      </div>

      {/* Stats Row */}
      <div className="compact-stats">
        <span className="compact-count">{challenge.count}</span>
        <span className="compact-percentage">{challenge.percentage.toFixed(0)}%</span>
      </div>

      {/* Priority Indicator */}
      <div className={`compact-priority priority-${challenge.priority}`}></div>
    </div>
  );
}
